module.exports = __webpack_public_path__ + "static/img/right.1ad5a78.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/right.png
// module id = yf19
// module chunks = 1